import { Link } from 'react-router-dom';
import type { Media } from '@/mocks/media';

interface MovieCardProps {
  item: Media;
}

const TYPE_LABEL: Record<string, string> = {
  movie: '电影',
  tv: '剧集',
};

export default function MovieCard({ item }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 海报`}
          title={`${item.title} - ${item.genres.join(' ')} ${item.year}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-950/80 text-background-50 text-xs font-medium">
          {TYPE_LABEL[item.type]}
        </span>
        <span className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-md bg-accent-500 text-primary-950 text-xs font-bold">
          <i className="ri-star-fill text-[10px]"></i>
          {item.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-2 bg-gradient-to-t from-primary-950/90 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
          <p className="text-background-50 text-xs line-clamp-2 leading-relaxed">{item.description}</p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">{item.title}</h3>
        <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
          <span className="whitespace-nowrap">{item.year}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
          <span className="truncate">{item.region}</span>
        </div>
        <div className="mt-2 flex flex-wrap gap-1">
          {item.genres.slice(0, 2).map((g) => (
            <span key={g} className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px]">
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}